import { useQueryParams } from "./useQueryParams";

export const ParseString = (v) => v;
export const ParseNumber = (v) => (v ? +v : v);

export const useQueryState = (
  key,
  defaultValue = null,
  parse = ParseString,
) => {
  const { getParam, setParam } = useQueryParams();

  const valueFromQuery = getParam(key);
  const value = parse(valueFromQuery) || defaultValue;

  const setValue = (newValue) => {
    setParam(key, newValue);
  };

  return [value, setValue];
};
